<template>
  <div
    @click="$emit('click')"
    class="player-progress">
    <h1
      class="player-progress-title">
      {{ title }}
    </h1>
    <f7-progressbar
      :progress="progress" />
    <div class="player-progress-subtitle">
      {{ subtitle }}
    </div>
  </div>
</template>

<script>
export default {
  name: 'PlayerProgress',
  props: {
    title: {
      type: String
    },
    subtitle: {
      type: String
    },
    progress: {
      type: Number
    }
  }
}
</script>

<style lang="scss">
.player-progress {
  display: block;
  position: relative;
  height: 60px;
  text-align: center;
  padding: 0;
  color: var(--f7-navbar-large-title-text-color);
  .player-progress-title,
  .player-progress-subtitle {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    margin: 0;
    margin: auto;
  }
  .player-progress-title {
    font-family: "Aleo";
    font-weight: bold;
    font-size: 16px;
    line-height: 30px;
  }
  .player-progress-subtitle {
    font-weight: normal;
    font-size: 13px;
    line-height: 25px;
  }
  .progressbar {
    background: #e6e6e6;
  }
}
.dark {
  .player-progress {
    .progressbar {
      background: #333;
    }
  }
}
</style>
